module.exports = __webpack_public_path__ + "static/media/daria.4494a74b.jpg";